// export const CONSOLE_LOG = (LOG) => {
//     fetch('https://bluejims.com:5005/CONSOLE/LOG', {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'Filter': JSON.stringify({ LOG: LOG})
//             // 'Populate': JSON.stringify(populateOptions)
//         }
//     });
// }
export const getUserByEmail = async (idToken, email) => {
    console.log('valkiria25db API - Fetching getPublicUserByEmail')
    const response = await fetch('https://bluejims.com:5005/user/findPublicUserByEmail', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'Filter': JSON.stringify({email: email})
            // 'Populate': JSON.stringify(populateOptions)
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const getGroupByName = async (idToken, groupName) => {
    console.log('valkiria25db API - Fetching findPublicGroupByName')
    const response = await fetch('https://bluejims.com:5005/misbolos/findPublicGroupByName', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'Filter': JSON.stringify({groupName: groupName})
            // 'Populate': JSON.stringify(populateOptions)
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const getPublicGroups = async (idToken, filter) => {
    if (!filter){
        filter = {}
    }
    console.log('valkiria25db API - Fetching publicGroups')
    const response = await fetch('https://bluejims.com:5005/misbolos/groups', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'Filter': JSON.stringify(filter)
            // 'Populate': JSON.stringify(populateOptions)
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const getPublicActivities = async (idToken, FILTER) => {
    console.log('valkiria25db API - Fetching publicActivities')
    const response = await fetch('https://bluejims.com:5005/misbolos/activities', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'Filter': JSON.stringify(FILTER)
            // 'Populate': JSON.stringify(populateOptions)
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const getPublicUsers = async (idToken, FILTER) => {
    console.log('valkiria25db API - Fetching publicUsers')
    const response = await fetch('https://bluejims.com:5005/user/publicUsers', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'Filter': JSON.stringify(FILTER)
            // 'Populate': JSON.stringify(populateOptions)
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const acceptJoinActivityReceivedRequest = async (idToken, requestId) => {
    console.log('valkiria25db API - Fetching acceptJoinActivityReceivedRequest')
    const response = await fetch('https://bluejims.com:5005/misbolos/acceptJoinActivityReceivedRequest', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'filter': JSON.stringify({ requestId: requestId })
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const denyJoinActivityReceivedRequest = async (idToken, requestId) => {
    console.log('valkiria25db API - Fetching acceptJoinActivityReceivedRequest')
    const response = await fetch('https://bluejims.com:5005/misbolos/denyJoinActivityReceivedRequest', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'filter': JSON.stringify({ requestId: requestId })
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}

export const acceptReceivedRequest = async (idToken, requestId) => {
    console.log('valkiria25db API - Fetching acceptReceivedRequest')
    const response = await fetch('https://bluejims.com:5005/user/acceptReceivedRequest', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'filter': JSON.stringify({ requestId: requestId })
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const denyReceivedRequest = async (idToken, requestId) => {
    console.log('valkiria25db API - Fetching denyReceivedRequest')
    const response = await fetch('https://bluejims.com:5005/user/denyReceivedRequest', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'filter': JSON.stringify({ requestId: requestId })
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const createGroupII = async (idToken, groupData) => {
    console.log('valkiria25db API - Fetching group')
    const response = await fetch('https://bluejims.com:5005/misbolos/groupII', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(groupData)
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const updateGroupMembersRemoveOne = async (idToken, groupData) => {
    console.log('valkiria25db API - Fetching updateGroupMembersRemoveOne')
    const response = await fetch('https://bluejims.com:5005/misbolos/updateGroupMembersRemoveOne', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(groupData)
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const updateGroupMembers = async (idToken, groupData) => {
    console.log('valkiria25db API - Fetching updateGroupMembers')
    const response = await fetch('https://bluejims.com:5005/misbolos/updateGroupMembers', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(groupData)
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const updateGroup = async (idToken, groupData) => {
    console.log('valkiria25db API - Fetching updateGroup')
    const response = await fetch('https://bluejims.com:5005/misbolos/updateGroup', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(groupData)
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}
export const updateUserProfile = async (idToken, updateData) => {
    console.log('valkiria25db API - Fetching updateUserProfile')
    const response = await fetch('https://bluejims.com:5005/user/updateUserProfile', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(updateData)
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}

export const findUserEmail = async (idToken, email) => {
    console.log('valkiria25db API - Fetching findUserEmail')
    const response = await fetch('https://bluejims.com:5005/user/email', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'Filter': JSON.stringify({ email: email })
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}

export const addProperty = async (idToken, newProperty) => {
    console.log('valkiria25db API - Fetching addProperty')
    const response = await fetch('https://bluejims.com:5005/user/addProperty', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(newProperty)
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return await response.json();
    }
}

export const createActivity = async (idToken, newActivity) => {
    console.log('valkiria25db API - Fetching createActivity')
    const response = await fetch('https://bluejims.com:5005/misbolos/activity', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(newActivity)
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        //TODO: Return more information...
        return false
    }
}
export const deleteGroup = async (idToken, groupId) => {
    console.log('valkiria25db API - Fetching deleteGroup')
    const response = await fetch('https://bluejims.com:5005/misbolos/deleteGroup', {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
            'Filter': JSON.stringify({ groupId: groupId})
            // 'Populate': JSON.stringify(populateOptions)
        }
    });

    if (response.ok) {
        console.log('✅ Data succesfully received from server');
        const responseData = await response.json();
        console.log('Server response:', responseData);
        return responseData
    } else {
        console.error('❌ Failed to send/receive data to bluejims.com:', response.status, response.statusText);
        // Handle non-2xx responses
        return false
    }
}